var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "customcheckerboard-color-control"
  }, [_c('div', {
    ref: "colorContainer",
    staticClass: "customcheckerboard-color-control-container"
  }, [_c('input', {
    ref: "colorInput",
    staticClass: "jscolor customcheckerboard-color-control-input",
    domProps: {
      "value": _vm.value
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }